import { apiService } from '.';
import { ILoginUser, IRegisterUser } from '../shared/types/auth';

export const asyncAuthRegister = async (formAuthRegister: IRegisterUser) => {
    return await apiService.post('/api/auth/register', formAuthRegister);
};

export const asyncAuthLogin = async (formAuthLogin: ILoginUser) => {
    return await apiService.post('/api/auth/login', formAuthLogin);
};

export const asyncAuthRefresh = async () => {
    // Protected endpoint, Authorization header is attached by ApiService
    return await apiService.post('/api/auth/refresh', {});
};

export const validatePermission = (
    permissions: any[],
    channelList: any[],
    type: string,
    channel: string
) => {
    const nameChannel =
        channelList?.filter((c) => c.id === channel)[0]?.name || '';
    const data = permissions?.find((p: any) => p === type || p === nameChannel);
    return data !== undefined;
};
